import { useIsIframeEmbed } from "@circle-react/hooks/useIsIframeEmbed";
import { useTailwindLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

export const useIsAppBarVisible = () => {
  const isLargeScreen = useTailwindLgScreenMediaQuery();
  const isIframeEmbed = useIsIframeEmbed();

  return !isLargeScreen && !isIframeEmbed;
};
